// Module
var code = "<svg class=\"image-cropper\"> <g class=\"image\"></g> <g class=\"crop\"></g> </svg> ";
// Exports
module.exports = code;